<div
  class="fixed inset-0 z-50 flex items-center justify-center p-3 md:p-5 bg-slate-900/60 backdrop-blur-sm animate-fade-in"
  (click)="onClose()">
  <div
    class="relative w-full max-w-xl max-h-[92vh] bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800 overflow-hidden flex flex-col"
    (click)="$event.stopPropagation()">

    <div *ngIf="isSaving() || isLoading()"
      class="absolute inset-0 bg-white/80 dark:bg-slate-900/80 z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <div class="flex-none px-6 py-5 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between gap-4">
      <div>
        <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">{{ isEdit ? 'edit' : 'event_available' }}</span>
          {{ isEdit ? 'แก้ไขช่วงยกเว้นค่าจอด' : 'เพิ่มช่วงยกเว้นค่าจอด' }}
        </h3>
        <p class="text-sm text-slate-500 dark:text-slate-400 mt-1 font-medium">
          ลาน: <span class="font-semibold text-amber-600 dark:text-amber-400">{{ siteName || '—' }}</span>
        </p>
      </div>
      <button type="button" (click)="onClose()" [disabled]="isSaving()"
        class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors disabled:opacity-50 border-none bg-transparent cursor-pointer">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="flex-1 overflow-y-auto custom-scrollbar px-6 py-6 space-y-5">
      <div *ngIf="isLocked"
        class="rounded-2xl border border-amber-200 dark:border-amber-800 bg-amber-50/80 dark:bg-amber-900/20 px-4 py-3 text-sm font-medium text-amber-800 dark:text-amber-300">
        ช่วงเวลายกเว้นเริ่มแล้ว ไม่สามารถแก้ไขได้
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
          ทะเบียนรถ <span class="text-rose-500">*</span>
        </label>
        <input type="text" [(ngModel)]="licensePlate" [disabled]="isEdit || isSaving()"
          placeholder="เช่น กข 1234"
          class="w-full h-[46px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60">
      </div>

      <div *ngIf="isEdit">
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Taiwan UUID</label>
        <input type="text" [ngModel]="taiwanUuid" disabled
          class="w-full h-[46px] px-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-mono opacity-70">
      </div>

      <div class="rounded-2xl border border-slate-100 dark:border-slate-800 bg-slate-50/60 dark:bg-slate-800/40 p-4 space-y-4">
        <p class="text-xs font-bold text-slate-400 uppercase tracking-wider flex items-center gap-1.5">
          <span class="material-icons text-amber-500 text-[16px]">schedule</span>
          ช่วงวันเวลายกเว้น <span class="text-rose-500">*</span>
          <span class="normal-case tracking-normal font-medium text-slate-400">(24 ชั่วโมง)</span>
        </p>

        <!-- เริ่มต้น -->
        <div>
          <label class="block text-[11px] font-bold text-slate-500 mb-1.5">เริ่มต้น</label>
          <div class="grid grid-cols-[1fr_110px] gap-2">
            <div class="relative">
              <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[18px] pointer-events-none z-10">event</span>
              <input type="text" [matDatepicker]="startPicker" [(ngModel)]="startDate"
                [disabled]="isLocked || isSaving()" placeholder="dd/mm/yyyy" readonly
                (click)="!isLocked && startPicker.open()"
                class="w-full h-[46px] pl-10 pr-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-sm font-bold focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60"
                [class.cursor-pointer]="!isLocked">
              <mat-datepicker #startPicker panelClass="modern-yellow-datepicker"></mat-datepicker>
            </div>
            <div class="relative">
              <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[18px] pointer-events-none">schedule</span>
              <input type="text" inputmode="numeric" maxlength="5" placeholder="HH:mm" [(ngModel)]="startTime"
                (blur)="onTimeBlur('start')" [disabled]="isLocked || isSaving()"
                class="w-full h-[46px] pl-10 pr-2 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-sm font-bold tabular-nums focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60">
            </div>
          </div>
          <div *ngIf="!isLocked" class="flex flex-wrap gap-1.5 mt-2">
            <button *ngFor="let t of timePresets" type="button" (click)="setTime('start', t)"
              class="px-2.5 py-1 rounded-lg text-[11px] font-bold border transition-colors cursor-pointer"
              [ngClass]="startTime === t
                ? 'bg-amber-400 border-amber-400 text-white'
                : 'bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700 text-slate-500 hover:border-amber-300 hover:text-amber-600'">
              {{ t }}
            </button>
          </div>
        </div>

        <!-- สิ้นสุด -->
        <div>
          <label class="block text-[11px] font-bold text-slate-500 mb-1.5">สิ้นสุด</label>
          <div class="grid grid-cols-[1fr_110px] gap-2">
            <div class="relative">
              <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[18px] pointer-events-none z-10">event</span>
              <input type="text" [matDatepicker]="endPicker" [(ngModel)]="endDate"
                [disabled]="isLocked || isSaving()" [min]="startDate" placeholder="dd/mm/yyyy" readonly
                (click)="!isLocked && endPicker.open()"
                class="w-full h-[46px] pl-10 pr-4 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-sm font-bold focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60"
                [class.cursor-pointer]="!isLocked">
              <mat-datepicker #endPicker panelClass="modern-yellow-datepicker"></mat-datepicker>
            </div>
            <div class="relative">
              <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[18px] pointer-events-none">schedule</span>
              <input type="text" inputmode="numeric" maxlength="5" placeholder="HH:mm" [(ngModel)]="endTime"
                (blur)="onTimeBlur('end')" [disabled]="isLocked || isSaving()"
                class="w-full h-[46px] pl-10 pr-2 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-sm font-bold tabular-nums focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60">
            </div>
          </div>
          <div *ngIf="!isLocked" class="flex flex-wrap gap-1.5 mt-2">
            <button *ngFor="let t of timePresets" type="button" (click)="setTime('end', t)"
              class="px-2.5 py-1 rounded-lg text-[11px] font-bold border transition-colors cursor-pointer"
              [ngClass]="endTime === t
                ? 'bg-amber-400 border-amber-400 text-white'
                : 'bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700 text-slate-500 hover:border-amber-300 hover:text-amber-600'">
              {{ t }}
            </button>
          </div>
        </div>

        <div *ngIf="rangePreview" class="flex items-center gap-2 text-xs font-bold rounded-xl px-3 py-2"
          [ngClass]="rangeInvalid
            ? 'bg-rose-50 text-rose-600 dark:bg-rose-900/20 dark:text-rose-400'
            : 'bg-amber-50 text-amber-700 dark:bg-amber-900/20 dark:text-amber-300'">
          <span class="material-icons text-[16px]">{{ rangeInvalid ? 'error_outline' : 'event_available' }}</span>
          {{ rangeInvalid ? 'วันเวลาสิ้นสุดต้องหลังวันเวลาเริ่มต้น' : rangePreview }}
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">หมายเหตุ</label>
        <textarea [(ngModel)]="remark" [disabled]="isLocked || isSaving()" rows="3"
          class="w-full px-4 py-3 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-60 resize-none"></textarea>
      </div>

      <div *ngIf="isEdit && logs().length" class="space-y-2">
        <p class="text-xs font-bold text-slate-400 uppercase tracking-wider">ประวัติซิงก์ Taiwan</p>
        <div class="rounded-2xl border border-slate-100 dark:border-slate-800 divide-y divide-slate-50 dark:divide-slate-800 max-h-40 overflow-y-auto custom-scrollbar">
          <div *ngFor="let log of logs()" class="px-3 py-2 text-xs">
            <div class="flex items-center justify-between gap-2">
              <span class="font-bold text-slate-700 dark:text-slate-200">{{ log.syncAction }} · {{ log.status }}</span>
              <span class="text-slate-400">{{ log.createDate | date:'dd/MM/yyyy HH:mm' }}</span>
            </div>
            <p *ngIf="log.errorMessage" class="text-rose-500 mt-1 truncate" [title]="log.errorMessage">{{ log.errorMessage }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="flex-none px-6 py-4 border-t border-slate-100 dark:border-slate-800 flex justify-between gap-3">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()"
        class="px-4 h-[42px] rounded-xl border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 font-bold bg-transparent cursor-pointer hover:border-amber-400 hover:text-amber-600 inline-flex items-center gap-1.5">
        <span class="material-icons text-base">history</span>
        ดูประวัติ
      </button>
      <div class="flex justify-end gap-3 ml-auto">
        <button type="button" (click)="onClose()"
          class="px-4 h-[42px] rounded-xl border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 font-bold bg-transparent cursor-pointer">
          ปิด
        </button>
        <button *ngIf="!isLocked" type="button" (click)="save()" [disabled]="isSaving()"
          class="px-5 h-[42px] rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold cursor-pointer disabled:opacity-50">
          บันทึก
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && id"
  [entityType]="activityEntityTypes.DiscountFreeRange"
  [entityId]="id"
  title="ประวัติช่วงยกเว้นค่าจอด"
  [subtitle]="'#' + id"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
